import { createReducer, createActions } from "reduxsauce";
import Immutable from "seamless-immutable";

const { Types, Creators } = createActions({
  getMeRequest: ["accessToken", "navigate"],
  getMeSuccess: ["status", "locale", "settings"],
  getMeFailure: null,
});

export const GetMeTypes = Types;
export default Creators;

export const INITIAL_STATE = Immutable({
  accessToken: null,
  data: null,
  fetching: false,
  success: false,
  error: false,
  status: null,
  locale: null,
  settings: null,
});

export const GetMeSelectors = {
  getData: (state: any) => state.getMe.data,
  isFetching: (state: any) => state.getMe.fetching,
  isSuccess: (state: any) => state.getMe.success,
  hasError: (state: any) => state.getMe.error,
  getAccessToken: (state: any) => state.getMe.accessToken,
  getStatus: (state: any) => state.getMe.status,
  getLocale: (state: any) => state.getMe.locale,
  getSettings: (state: any) => state.getMe.settings,
};

export const request = (state: any, { accessToken, navigate }: any) => {
  const updateData = {
    accessToken: accessToken,
    fetching: true,
    success: false,
    error: false,
    status: null,
    locale: null,
    settings: null,
  };
  
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const success = (state: any, action: any) => {
  const { status, locale, settings } = action;
  const updateData = {
    data: { status, locale, settings }, // Store complete data object
    fetching: false,
    success: true,
    error: false,
    status,
    locale,
    settings,
  };
  
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const failure = (state: any) => {
  const updateData = {
    fetching: false,
    success: false,
    error: true,
    status: null,
    locale: null,
    settings: null,
  };
  
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_ME_REQUEST]: request,
  [Types.GET_ME_SUCCESS]: success,
  [Types.GET_ME_FAILURE]: failure,
});
